import React, { Component } from 'react';
import { message, Tabs, Button } from 'antd';
import md5 from "react-native-md5";
import qs from 'qs';
import {
    getToken,getUrl
} from '../../apis/api'

const { TabPane } = Tabs;

class Blankpage extends Component {

  constructor(props) {
    super(props);
    this.state={
        
    }
}

componentWillMount(){
    // let URL = window.location.href;
    // let code = qs.parse(URL.split("?")[1]).code;
    // if(code){
    //     this.getToken(code)
    // }
    this.getUrl()
}

getUrl(){
    getUrl().then( (data)=> {
        if(data.code === 0){
            window.location.href = data.content
        }else{
            message.error(data.message); 
        }
    });
}
getToken(code){
    let _this=this;
    let params={
        code:code,
        source:'cgj'
    }
    getToken(params).then( (data)=> {

        if(data.code === 0){

            let access_token=data.content.access_token;
            sessionStorage.setItem('access_token',access_token);
            _this.props.history.push('/home')

        }else{
            message.error(data.message); 
        }
    });
}

   componentWillUnmount(){
    // 在卸载的时候对所有的操作进行清除
    this.setState = (state,callback)=>{
        return;
      };
   }

  render() {

    return (
      <div className="blank_page">
          {/* 空白页 */}
      </div>
    );
  }
}

export default Blankpage;



// WEBPACK FOOTER //
// ./src/page/Blankpage/index.js